import "./styles.css";

import { DropDownItem, PageTitle } from "../../components";

import BgImage from "../../assets/images/massage-bg.webp";
import { Fade } from "react-awesome-reveal";
import { Helmet } from "react-helmet-async";
import logoOg from "../../assets/images/logoog.jpg";

const Massage = () => {
  return (
    <div className="py-12 bg-white">
      <Helmet>
        <title>Kenworthy Chiropractic | Massage</title>
        <meta
          property="og:description"
          content="Kenworthy Chiropractic – Massage therapy to coincide with your chiropractic treatment."
        />
        <meta
          property="og:title"
          content={`Kenworthy Chiropractic | Massage`}
        />
        <meta property="og:type" content="website" />"
        <meta property="og:url" content={window.location.href} />
        <meta property="og:image" content={logoOg} />
        <meta property="og:image:secure_url" content={logoOg} />
        <meta property="og:image:width" content="1920" />
        <meta property="og:image:height" content="1080" />
      </Helmet>

      <div className="max-w-5xl px-5 mx-auto">
        <PageTitle title="Massage" />
        <div className="relative px-5 top-info-container">
          <Fade direction="right" triggerOnce>
            <img
              loading="lazy"
              src={BgImage}
              alt="massage"
              className="absolute top-[-10px] right-[-70px] h-[550px] w-auto z-[0] massage-image"
            />
          </Fade>
          <Fade direction="up" triggerOnce>
            <div className="relative mr-[28%] z-[2] text-container">
              <p className="text-gray-600">
                Studies have shown that massage therapy is extremely effective
                for chronic pain conditions, even more so when used alongside
                other treatment such as chiropractic care, so we like to get the
                best results by combining massage and chiropractic care
                together.
                <a
                  href="/citations"
                  className="text-[#846bb9] hover:text-[#6bb2b9] ml-[2px]"
                >
                  <sup>[1]</sup>
                </a>
              </p>
              <br />
              <p className="text-gray-600">
                Our massage therapists work very closely with the chiropractors
                to ensure they are delivering targeted and focussed massage
                where you need it most.
                <a
                  href="/citations"
                  className="text-[#846bb9] hover:text-[#6bb2b9] ml-[2px]"
                >
                  <sup>[2]</sup>
                </a>
              </p>
              <br />
              <p className="text-gray-600">
                Our massage therapy room is designed with comfort and relaxation
                in mind, with soft fluffy towels, a thick fleecy cover and an
                electric blanket for those cooler months! This is an environment
                where you can truly relax, safe in the knowledge that you are
                being looked after by a full team of professionals.
              </p>
            </div>
          </Fade>
        </div>
        <Fade triggerOnce cascade damping={0.1}>
          <div className="max-w-full mt-5 mb-10">
            <DropDownItem
              defaultOpenState={true}
              title="We offer a wide range of massage services including:"
              data={[
                { title: "Deep-Tissue Massage (30 min or 60 min)" },
                { title: "Pregnancy Massage (60 min)" },
                { title: "Post-Natal Massage (60min)" },
              ]}
              disabled={false}
              grid={false}
              listStyled
            />
          </div>
          <p className="text-gray-600 font-bold text-2xl mb-2">
            Soft Tissue Manipulation
          </p>
          <div className="relative px-5 mt-5">
            <p className="text-gray-600">
              Soft tissue manipulation involves massage and gentle joint
              articulation to release tension in tissue which can cause pain and
              dysfunction throughout the body. It aims to improve mobility and
              function of muscles, tendons, ligaments, fascia and joints as well
              as improve circulation and reduce discomfort.
            </p>
          </div>
          <div className="max-w-full mt-5 mb-10">
            <DropDownItem
              defaultOpenState={true}
              title="This therapeutic approach can be particularly beneficial for: "
              data={[
                { title: "Managing long-term health conditions" },
                {
                  title:
                    "Supporting rehabilitation following surgery or injury ",
                },
                { title: "Easing muscular tension from day-to-day living" },
                {
                  title:
                    "Supporting postpartum recovery from any of the common postnatal aches and pains.",
                },
              ]}
              disabled={false}
              grid={false}
              listStyled
            />
          </div>
          <p className="text-gray-600 font-bold text-2xl  ">
            Mum and Baby-Friendly Appointments
          </p>
          <div className="relative px-5 mt-5">
            <p className="text-gray-600">
              Ceciel will be offering pregnancy massage from September 2026.
              While she currently does not treat children, you are welcome to
              bring your baby or older children and we can pause the session at
              any time for cuddles, feeding, or settling.
            </p>
          </div>

          <div className="relative px-5 mt-5">
            <p className="text-gray-600">
              Don’t hesitate to get in touch with us to discuss what you are
              looking for, whether this be a relaxing massage, release and
              relief of tension, pre- or post-race preparation or to aid
              recovery from injury, we can help!
            </p>
          </div>
        </Fade>
      </div>
    </div>
  );
};

export default Massage;
